/**
 * @generated SignedSource<<49fcc0d5872996dc7acfbff2669b5cbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNotePageImageMode_widgetNotePage$data = {
  readonly fontColor: string | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNoteText_page" | "useNoteWidgetStyleText_widgetNotePage" | "useToggleFontColor_page">;
  readonly " $fragmentType": "WidgetNotePageImageMode_widgetNotePage";
};
export type WidgetNotePageImageMode_widgetNotePage$key = {
  readonly " $data"?: WidgetNotePageImageMode_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePageImageMode_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNotePageImageMode_widgetNotePage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetNoteText_page"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontColor",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useToggleFontColor_page"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNoteWidgetStyleText_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "8492a3a13e65f203d2b28fb3dab75b1a";

export default node;
